export default {
  account: {
    attributes: {
      name: 'Name',
      type: 'Type',
    },
    header: {
      title: 'Email service',
      subtitle: 'Set up an Email Service you use, or all of them!',
      searchAccount: 'Search for an Account',
    },
    list: {
      insert_date: 'Added on',
      actions: 'Actions',
      deprecated: 'Deprecated',
    },
    editModal: {
      header: 'Add email service account',
      helpBlock: 'Please fill in the form below.',
      select: 'Select',
      save: 'Save',
      activeCampaign: {
        apiKey: 'Key',
        apiKeyPlaceholder: 'API Key',
        apiUrl: 'URL',
        apiUrlPlaceholder: 'API URL',
      },
      aweber: {
        help: 'To conclude integration with Aweber, click on Save below.',
      },
      convertKit: {
        apiKey: 'Key',
        apiKeyPlaceholder: 'API Key',
        apiSecret: 'Secret',
        apiSecretPlaceholder: 'API Secret',
      },
      eGoi: {
        apiKey: 'Your API Key',
      },
      getResponse: {
        apiKey: 'GetResponse API Key',
        apiKeyPlaceholder: 'API Key',
      },
      mailChimp: {
        apiKey: 'Mailchimp API Key',
        apiKeyPlaceholder: 'API Key',
      },
      rdStation: {
        apiKey: 'Your Token',
        apiKeyPlaceholder: 'Token',
        help: 'To finish the integration with RD Station, click the Save button below.',
      },
    },
    types: {
      getResponse: 'GetResponse',
      activeCampaign: 'Active Campaign',
      aweber: 'Aweber',
      convertKit: 'ConvertKit',
      eGoi: 'E-Goi',
      mailChimp: 'MailChimp',
      rdStation: 'RD Station',
    },
    actions: {
      new: 'NEW ACCOUNT',
      edit: 'Edit',
      delete: 'Delete',
    },
    notify: {
      success: {
        delete: 'Email service successfully deleted.',
        create: 'Email service successfully saved.',
        update: 'Email service successfully updated.',
      },
      error: {
        aweber: 'There was an error connecting to Aweber',
        rdstation: 'There was an error while connecting to RDStation',
      },
    },
  },
  modal: {
    delete: {
      title: 'DELETE',
      message: 'Are you sure you wish to delete this email service? This action cannot be undone!',
      confirm: 'YES, delete',
      cancel: 'Cancel',
    },
  },
  notifications: {
    noNotifications: 'There are no new notifications.',
    unableLoad: 'We were unable to load notifications at this time.',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/messages/languages/enUs.js